export default __webpack_public_path__ + "static/media/confirm.68929cc3.svg";